import { AppIcons } from "../../../../data/appIcons";
import { GridColumnType } from "../../../../data/gridColumnType";

export const CertificateCorporateListConfig = {
  columns: [
    {
      name: "Company Name",
      fieldName: "companyName",
      colType: GridColumnType.Text,
    },
    {
      name: "Company UEN",
      fieldName: "companyUEN",
      colType: GridColumnType.Text,
    },
    {
      name: "Product Applications",
      fieldName: "productApplications",
      colType: GridColumnType.Text,
    },
    {
      name: "Product Certifications",
      fieldName: "productCertifications",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Services Applications",
      fieldName: "serviceApplications",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Services Certifications",
      fieldName: "serviceCertifications",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Actions",
      fieldName: "actions",
      allowShort: false,
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete: false,
      },
      customAction: [
        {
          name: "View",
          // iconName: AppIcons.editIconNew,
          onViewAction: (data) => {
            alert("called permissions");
          },
        },
      ],
    },
  ],
};
